<template>
  <div class="form-abm validacion-abm">
    <b-card :header="title">
      <b-form>
        <b-form-group
          label="Aprobado"
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="validacionAprobada"
              v-model="validacionAprobada"
              :value="Boolean(true)"
              :unchecked-value="Boolean(false)">
              {{ description }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :label-cols="labelCols"
          horizontal>
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="3"
            max-rows="3"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'validacion/getField',
  mutationType: 'validacion/updateField',
});

export default {
  name: 'ValidacionABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    validacionIdentidad: {
      type: Boolean,
      default: true
    },
    eventoId: {
      type: Number,
      default: 0
    },
    participanteId: {
      type: Number,
      default: 0
    },
    eventoEtapaId: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'validacionAprobada',
      'observaciones',
    ]),
    title() {
      if ((/true/i).test(this.validacionIdentidad)) {
        return 'Validar Identidad';
      } else {
        return 'Validar Participación';
      }
    },
    description() {
      if ((/true/i).test(this.validacionIdentidad)) {
        return 'Validación de identidad aprobada';
      } else {
        return 'Validación de participación aprobada';
      }
    }
  },  
  created() {
    let params= {
      validacionIdentidad: this.validacionIdentidad,
      eventoId: this.eventoId,
      participanteId: this.participanteId,
      eventoEtapaId: this.eventoEtapaId
    }

    this.showSpinner();
    this.$store.dispatch('validacion/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          } 
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('validacion/save')
            .then(()  => this.showModalMsj('La validación se registró con éxito.', this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    close(saved) {
      let validacionSaved = false | saved;

      this.$emit('close', validacionSaved);
    },
  },
  watch: {
  },
  validations: {
    observaciones: {
      // required,
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
  .validacion-abm .custom-control {
    top: 8px;
  }
  .validacion-abm .custom-control label {
    font-size: 12px;
    font-style: italic;
  }
</style>
